(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rhodi-cro-story"] && !Shopify.designMode) return;
  try {
    
  const initRhodiStoryCarousels = (scope = document) => {
    scope.querySelectorAll('[data-rhcro-carousel]').forEach((track) => {
      if (track.dataset.rhcroReady === 'true') return;

      const carousel = track.closest('.rhcro-story__carousel');
      const dots = [...carousel.querySelectorAll('[data-rhcro-dot]')];
      const cards = [...track.querySelectorAll('.rhcro-story__proof')];
      if (cards.length === 0 || dots.length !== cards.length) return;

      const targetPosition = (index) => {
        const lastPosition = Math.max(0, track.scrollWidth - track.clientWidth);
        if (index === 0) return 0;

        const trackRect = track.getBoundingClientRect();
        const cardRect = cards[index].getBoundingClientRect();
        const cardLeft = cardRect.left - trackRect.left + track.scrollLeft;
        if (index === cards.length - 1) {
          const endPosition = cardLeft + cardRect.width - track.clientWidth;
          return Math.min(lastPosition, Math.max(0, endPosition));
        }

        const centeredPosition = cardLeft - ((track.clientWidth - cardRect.width) / 2);
        return Math.min(lastPosition, Math.max(0, centeredPosition));
      };

      const currentIndex = () => cards.reduce((closest, _card, index) => {
        const distance = Math.abs(targetPosition(index) - track.scrollLeft);
        return distance < closest.distance ? { index, distance } : closest;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;

      const updateControls = () => {
        const activeIndex = currentIndex();
        dots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          track.scrollTo({ left: targetPosition(index), behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', () => window.requestAnimationFrame(updateControls), { passive: true });
      window.addEventListener('resize', updateControls);
      track.dataset.rhcroReady = 'true';
      updateControls();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRhodiStoryCarousels());
  } else {
    initRhodiStoryCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => initRhodiStoryCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rhodi-hero"] && !Shopify.designMode) return;
  try {
    
  function initRhodiLineupHeroes(scope) {
    (scope || document).querySelectorAll('[data-rhodi-lineup-hero]').forEach(function (hero) {
      if (hero.dataset.rhlReady === 'true') return;

      var track = hero.querySelector('[data-rhl-track]');
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-rhl-slide]'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-rhl-dot]'));
      if (!track || !slides.length || slides.length !== dots.length) return;

      var firstClone = slides[0].cloneNode(true);
      var lastClone = slides[slides.length - 1].cloneNode(true);
      firstClone.removeAttribute('data-rhl-slide');
      lastClone.removeAttribute('data-rhl-slide');
      firstClone.setAttribute('data-rhl-clone', 'true');
      lastClone.setAttribute('data-rhl-clone', 'true');
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      firstClone.inert = true;
      lastClone.inert = true;
      track.insertBefore(lastClone, slides[0]);
      track.appendChild(firstClone);

      var logicalIndex = 0;

      function jumpToPhysicalIndex(index) {
        var previousBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = index * track.clientWidth;
        track.offsetHeight;
        track.style.scrollBehavior = previousBehavior;
      }

      function physicalIndex() {
        if (!track.clientWidth) return 1;
        return Math.max(0, Math.min(slides.length + 1, Math.round(track.scrollLeft / track.clientWidth)));
      }

      function currentIndex() {
        var current = physicalIndex() - 1;
        if (current < 0) return slides.length - 1;
        if (current >= slides.length) return 0;
        return current;
      }

      function update() {
        var active = currentIndex();
        logicalIndex = active;
        dots.forEach(function (dot, index) {
          if (index === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        slides.forEach(function (slide, index) {
          slide.setAttribute('aria-hidden', index === active ? 'false' : 'true');
          slide.inert = index !== active;
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          logicalIndex = index;
          track.scrollTo({ left: (index + 1) * track.clientWidth, behavior: 'smooth' });
        });
      });

      function normalizeEdge() {
        var current = physicalIndex();
        if (current === 0) jumpToPhysicalIndex(slides.length);
        else if (current === slides.length + 1) jumpToPhysicalIndex(1);
        update();
      }

      var scheduled = false;
      var scrollEndTimer;
      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = window.setTimeout(normalizeEdge, 120);
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          update();
        });
      }, { passive: true });
      track.addEventListener('scrollend', normalizeEdge);
      window.addEventListener('resize', function () {
        jumpToPhysicalIndex(logicalIndex + 1);
        update();
      });

      hero.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var target = document.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });

      hero.dataset.rhlReady = 'true';
      window.requestAnimationFrame(function () {
        jumpToPhysicalIndex(1);
        update();
      });
    });
  }

  function setRhodiHeroOffset() {
    var hero = document.getElementById('rh-hero');
    if (!hero) return;
    var offset = Math.round(hero.getBoundingClientRect().top + window.scrollY);
    document.documentElement.style.setProperty('--rh-hero-offset', offset + 'px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRhodiLineupHeroes(document);
      setRhodiHeroOffset();
    });
  } else {
    initRhodiLineupHeroes(document);
    setRhodiHeroOffset();
  }
  window.addEventListener('resize', setRhodiHeroOffset);
  document.addEventListener('shopify:section:load', function (event) {
    initRhodiLineupHeroes(event.target);
    setRhodiHeroOffset();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rhodi-topbar"] && !Shopify.designMode) return;
  try {
    
  class RhodiAnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('visibilitychange', () => this.refresh(), options);
      window.addEventListener('pageshow', () => this.refresh(), options);
      this.refresh();
      this.rotationTimer = setInterval(() => {
        this.refresh();
        if (document.hidden || this.contains(document.activeElement)) return;
        const slides = [...this.querySelectorAll('.rhodi-topbar__slide')];
        const current = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (slides.length > 1) this.activate(slides[(current + 1) % slides.length]);
      }, 4500);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearInterval(this.rotationTimer);
      clearTimeout(this.expiryTimer);
    }

    activate(active) {
      this.querySelectorAll('.rhodi-topbar__slide').forEach((slide) => {
        const selected = slide === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', String(!selected));
        slide.inert = !selected;
      });
    }

    refresh() {
      clearTimeout(this.expiryTimer);
      const campaign = this.querySelector('[data-halloween-announcement]');
      if (campaign) {
        const remaining = Date.parse(campaign.dataset.endsAt) - Date.now();
        if (!Number.isFinite(remaining) || remaining <= 0) campaign.remove();
        else this.expiryTimer = setTimeout(() => this.refresh(), Math.min(remaining, 2147483647));
      }
      this.activate(this.querySelector('.rhodi-topbar__slide.is-active') || this.querySelector('.rhodi-topbar__slide'));
    }
  }

  if (!customElements.get('rhodi-announcement-bar')) customElements.define('rhodi-announcement-bar', RhodiAnnouncementBar);

  } catch(e) { console.error(e); }
})();
})();
